import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Container } from 'components';
import Dashboard from './dashboard';
import { SidebarLeft } from 'components';
import { Link } from 'react-router';

class SalesSiteManagerContainer extends React.Component {
  componentWillUnmount() {

  }
  render() {
    return (
      <Container>
        <SidebarLeft>
          <Link className='pull-right bg-dark p-xs' to='/sales-site/pages/create'><i className='fa fa-plus'></i> New</Link>
          <h4 className='title'>Pages</h4>
          <ul className='list-unstyled mg-folders'>
            <li>
              <Link className='menu-item' to='/sales-site/pages'><i className='fa fa-list'></i> List</Link>
            </li>
            <li>
              <Link className='pull-right btn btn-sm btn-primary mt-xs' to='/sales-site/page-templates/create'><i className='fa fa-plus'></i> Add</Link>
              <Link className='menu-item' to='/sales-site/page-templates'><i className='fa fa-folder'></i> Templates</Link>
            </li>
          </ul>

          <Link className='pull-right mt-xs bg-dark p-xs' to='/sales-site/sections/create'><i className='fa fa-plus'></i> New</Link>
          <h4 className='title'>Sections</h4>
          <ul className='list-unstyled mg-folders'>
            <li>
              <Link className='menu-item' to='/sales-site/sections'><i className='fa fa-list'></i> List</Link>
            </li>
            <li>
              <Link className='pull-right btn btn-sm btn-primary mt-xs' to='/sales-site/section-templates/create'><i className='fa fa-plus'></i> Add</Link>
              <Link className='menu-item' to='/sales-site/section-templates'><i className='fa fa-folder'></i> Templates</Link>
            </li>
          </ul>
          <h4 className='title'>Menu</h4>
          <ul className='list-unstyled mg-folders'>
            <li>
              <Link className='menu-item' to='/sales-site/menu-settings'><i className='fa fa-cogs'></i> Settings</Link>
            </li>
          </ul>
          <Link className='pull-right mt-xs bg-dark p-xs' to='/sales-site/plans/create'><i className='fa fa-plus'></i> New</Link>
          <h4 className='title'>Plans</h4>
          <ul className='list-unstyled mg-folders'>
            <li>
              <Link className='menu-item' to='/sales-site/plans'><i className='fa fa-list'></i> List</Link>
            </li>
          </ul>
          <h4 className='blog'></h4>
        </SidebarLeft>
        {this.props.children || (
          <Dashboard />
        )}
      </Container>
    )
  }
}

export default SalesSiteManagerContainer;



// WEBPACK FOOTER //
// ./src/browser/components/sales-site-manager/container.js